import Schelude from "./Schelude";
import './style.css'

export default function GrillaResult({datosProgramas, categorie, currentData}){
    //console.log({datosProgramas, currentSec})
    return (
            <Schelude datosProgramas={datosProgramas} categorie={categorie} currentData={currentData} />
    );
}